import React from 'react';
import { ReactEditor } from 'slate-react';
import { Transforms } from 'slate';
import Tool, {
  type ToolArgs,
  type ToolArgsWithController,
} from '../../../tools/Tool';
import { isMediaElement } from '../../../types/guards';
import MediaCommon from '../MediaCommon';
import classnames from 'classnames';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import ToolBorderColorPicker from './ToolBorderColorPicker';
import { type MediaElement } from '../../../types/aha-editor';
import ColorUtils from '../../../util/color';

class ToolBorderColor extends Tool {
  static toolName = 'Border color';

  static action(args: ToolArgs & { color?: string }): void {
    const { editor, element, color } = args;

    if (!element || !isMediaElement(element)) return;

    const path = ReactEditor.findPath(editor, element);

    if (color) {
      const mappedColor = ColorUtils.mapColorFromColorPickerFromDarkMode(color);

      // If setting a border color and no border width is set, set default width
      const updates: Pick<
        MediaElement,
        'media_borderColor' | 'media_borderWidth'
      > = { media_borderColor: mappedColor };
      if (element.media_borderWidth === undefined) {
        updates.media_borderWidth = MediaCommon.defaultBorderWidth;
      }
      Transforms.setNodes(editor, updates, { at: path });
    } else {
      Transforms.setNodes(
        editor,
        {
          media_borderColor: undefined,
          media_borderWidth: undefined,
        },
        { at: path }
      );
    }
  }

  static renderToolbarButtonIcon(
    toolArgs: ToolArgsWithController
  ): JSX.Element {
    const { element } = toolArgs;

    if (!element || !isMediaElement(element)) return <></>;

    const mappedColor = element.media_borderColor
      ? ColorUtils.mapColorFromColorPickerToDarkMode(element.media_borderColor)
      : undefined;

    return element.media_borderColor ? (
      <span
        className={styles.borderColorIcon}
        style={{ borderColor: mappedColor }}
      />
    ) : (
      <span
        className={classnames(styles.borderColorIcon, styles.colorIconNone)}
      />
    );
  }

  static submenuTools = () => [[ToolBorderColorPicker]];
  static submenuType = 'icons' as const;
}

export default ToolBorderColor;
